import { Component } from '@angular/core';
import { BasePageController } from '../BasePage';
import { timer } from 'rxjs';
import moment from 'moment';

import { OfferService } from '@services/offer/offer.service';
import { InAppBrowserService } from '@services/api/in-app-browser/in-app-browser.service';
import { environment } from 'src/environments/environment';
import { AnalyticsEventEnum } from '@models/AnalyticsEventEnum';
import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';
import { ErrorReportService, IErrorReport } from '@services/error-report/error-report.service';
import { EstudoService } from '@services/api/estudo/estudo.service';
import { ApplePurchaseService } from '@services/api/apple-purchase/apple-purchase.service';
import { FirebaseAnalyticsService } from '@services/analytics/firebase-analytics.service';
import { EventService } from '@services/event-service/event.service';

const PLANO_ANUAL_PROMO = 'plano_anual_promo';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.page.html',
  styleUrls: ['./promo.page.scss']
})
export class PromoPage extends BasePageController {
  dateRemaining: string = '';
  limit = new Date('2025-12-31');
  constructor(
    private offerService: OfferService,
    private inAppBrowserService: InAppBrowserService,
    private estudoService: EstudoService,
    private iap: InAppPurchase,
    private errorReportService: ErrorReportService,
    private applePurchase: ApplePurchaseService,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    private events: EventService
  ) {
    super();
  }

  async ngOnInit() {
    this.limit = await this.offerService.readCountDownDate();
    const source = timer(1000, 1000);
    const subscribiton = source.subscribe(() => {
      this.dateRemaining = this.calculateTimeRemaining(this.limit);
    });
    this.pushSubscription(subscribiton);
    this.analyticsService.logEvent(AnalyticsEventEnum.POPUP_PROMO, { countdown: this.limit });
  }

  ngOnDestroy() {
    this.unsubscribeAllSubscriptions();
  }

  close() {
    this.analyticsService.logEvent(AnalyticsEventEnum.BT_PROMO_CLOSE);
    this.modalCtrl.dismiss();
  }

  calculateTimeRemaining(targetDate: Date): string {
    const now = new Date().getTime(); // Data e hora atuais em milissegundos
    const endDate = new Date(targetDate).getTime(); // Data de destino em milissegundos
    const timeDifference = endDate - now; // Diferença em milissegundos

    if (timeDifference <= 0) {
      return '0d 0h 0m 0s';
    }

    const seconds = Math.floor((timeDifference / 1000) % 60);
    const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  async handleOpenCheckout() {
    if (this.isIOS) {
      this.buyIOS();
    } else {
      this.openCkeckout();
    }
  }

  async buyIOS() {
    await this.showLoading();

    try {
      await this.iap.getProducts([PLANO_ANUAL_PROMO]);
      const data = await this.iap.subscribe(PLANO_ANUAL_PROMO);
      const { receipt, transactionId } = data;
      this.analyticsService.logEvent('APPLE_BUY', { receipt, transactionId });

      await this.persistPurchase(receipt, transactionId);
      this.close()
    } catch (error) {
      const errorReport: IErrorReport = {
        sentry: {
          err: error,
          tags: { buyIOS: 'apple' },
          data: { location: 'promo' }
        },
        amplitude: {
          event: 'APPLE_BUY_SUBSCRIPTION_ERROR_PROMO',
          data: {
            error
          }
        }
      };

      this.errorReportService.sendReport(errorReport);
    } finally {
      this.dismissLoading();  
    }
  }

  async persistPurchase(receipt, transactionId) {
    const expiryDate = moment();
    expiryDate.add(365, 'days');

    const planos: any[] = await this.estudoService.getPlanos();
    const plano = planos.find((p) => p.id_moip === 'Estudaqui_Anual');

    const subscription = {
      customer_id: this.userStoreService.user.objectId,
      plan_id_moip: plano.id_moip,
      plan_id: plano.objectId,
      expiry_date: expiryDate.format(),
      coupon_code: null,
      receipt,
      transactionId,
      amount: parseInt(plano.price.replace(/\D/g, '')) / 100,
    };

    await this.applePurchase.purchase({
      assinatura: subscription,
    });

    this.analyticsService.logEvent('APPLE_BUY_PERSIST', subscription);
    this.firebaseAnalyticsService.logEvent('purchase', { planId: subscription.plan_id, amount: subscription.amount })
    this.events.publish('subscription:inAppPurchase');
  }

  openCkeckout() {
    const userEmail = this.userStoreService.user.email;
    const linkCheckout = 'https://app.estudaqui.com/assinar';

    const url = new URL(linkCheckout);
    url.searchParams.append('email', userEmail);
    url.searchParams.append('plano', 'anual_com_desconto');
    url.searchParams.append('utm_source', 'app_estudaqui');
    url.searchParams.append('utm_medium', 'popup_promo'); // ajuste conforme o local da promoção
    url.searchParams.append('utm_campaign', environment.appVersionCode.toString());
    url.searchParams.append('utm_content', 'versao_a');
    const urlString = url.toString();

    this.analyticsService.logEvent(AnalyticsEventEnum.BT_PROMO_OPEN_CHECKOUT, { url: urlString });

    this.inAppBrowserService.openLinkOnBrowser(urlString);
  }
}
